/** 格式化箱子名称 */
export const format_case_name = (case_name) => {
	if (typeof case_name === 'undefined') {
		return '';
	}

	return case_name.replace(/\(推荐\)$/, '');
};
